import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from 'context/StoreContext';
import { LoadingScreen, EmptyState } from 'components/common/Spinner';
import { Store } from 'lucide-react';

export function TenantGate({ children }: { children: React.ReactNode }) {
  const { org, currentStore, loading, error } = useStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !error && !org) navigate('/onboarding', { replace: true });
  }, [loading, error, org, navigate]);

  if (loading) return <LoadingScreen />;
  if (error) return (
    <EmptyState
      title="We couldn't load your account"
      message={error}
      action={<button onClick={() => window.location.reload()} className="text-sm font-medium text-blue-600 hover:underline">Try again</button>}
    />
  );
  if (!org) return null;
  if (!currentStore) return (
    <EmptyState
      icon={<Store size={40} />}
      title="No store available"
      message="Your account isn't assigned to any store yet. Ask your account owner to add a store or assign you to one."
    />
  );
  return <>{children}</>;
}